import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { PackageTranslationFormInput } from "../../../types/FormFields";
import ReactQuill from "react-quill";
import LangContext from "../../../context/LanguageContext";
import PkgService from "../../../services/PkgService";
import { MsgSuccess } from "../../../components/Loaders/MessageLoaders";

export interface IPkgTransInput extends PackageTranslationFormInput {
  id?: string;
  pkg?: string;
  lang?: string;
}

const PackageTranslationForm = ({ pkgId }: { pkgId: string }) => {
  const [overview, setOverview] = useState<string>("");
  const [imp_info, setImpInfo] = useState<string>("");
  const [itinary, setItinary] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [isTranslationData, setIsTranslationData] = useState<IPkgTransInput>();

  const { lang_id, lang } = useContext(LangContext);

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<PackageTranslationFormInput>();

  const onSubmit = handleSubmit(async (formInput) => {
    try {
      setLoading(true);
      const data: IPkgTransInput = formInput;
      if (overview.length === 0) {
        setError("overview", {
          message: "Overview is required!",
        });
      }
      if (imp_info.length === 0) {
        setError("imp_info", {
          message: "Imp_info is required!",
        });
      }
      if (itinary.length === 0) {
        setError("itinary", {
          message: "Itinary is required!",
        });
      }
      data["overview"] = overview;
      data["itinary"] = itinary;
      data["imp_info"] = imp_info;
      data["pkg"] = pkgId;
      data["lang"] = lang_id;

      if (isTranslationData) {
        const res = await PkgService.updateTranslation(
          isTranslationData.id!,
          data
        );
        MsgSuccess(res.data.message);
      } else {
        const res = await PkgService.createTranslation(data);
        MsgSuccess(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  });

  const fetchTranslation = async () => {
    try {
      const res = await PkgService.fetchTranslation(pkgId, lang_id);
      if (res.data.data) {
        setIsTranslationData(res.data.data);
        setValue("package_title", res.data.data.package_title);
        setOverview(res.data.data.overview);
        setItinary(res.data.data.itinary);
        setImpInfo(res.data.data.imp_info);
        setValue("package_summary", res.data.data.package_summary);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchTranslation();
  }, [pkgId, lang_id]);

  return (
    <div className="py-5">
      <form action="" onSubmit={onSubmit}>
        <div className="flex flex-col space-y-2">
          <label htmlFor="title">Package title {`(${lang}) *`}</label>
          <input
            type="text"
            id="title"
            className="form-input inputs"
            {...register("package_title", { required: true })}
          />
          {errors.package_title && (
            <span className="text-red-500">This field is required</span>
          )}
        </div>

        <div className="flex flex-col space-y-2 my-3">
          <label htmlFor="summary">
            Package Summary (use comma inbetween the summary items){" "}
          </label>
          <textarea
            rows={3}
            id="summary"
            className="form-input inputs"
            {...register("package_summary", { required: true })}
          />
          {errors.package_summary && (
            <span className="text-red-500">This field is required</span>
          )}
        </div>

        <div className="flex flex-col space-y-2 my-3">
          <label htmlFor="">Overview {`(${lang}) *`}</label>
          <ReactQuill theme="snow" value={overview} onChange={setOverview} />
          {errors.overview && (
            <span className="text-red-500">{errors.overview.message}</span>
          )}
        </div>

        <div className="flex flex-col space-y-2 my-3">
          <label htmlFor="">Important Info {`(${lang}) *`}</label>
          <ReactQuill theme="snow" value={imp_info} onChange={setImpInfo} />
          {errors.imp_info && (
            <span className="text-red-500">{errors.imp_info.message}</span>
          )}
        </div>

        <div className="flex flex-col space-y-2 my-3">
          <label htmlFor="">Itinary {`(${lang}) *`}</label>
          <ReactQuill theme="snow" value={itinary} onChange={setItinary} />
          {errors.itinary && (
            <span className="text-red-500">{errors.itinary.message}</span>
          )}
        </div>

        <div className="my-4">
          <input
            type="submit"
            value={
              loading ? "Loading" : isTranslationData ? "Update" : "Submit"
            }
            disabled={loading}
            className="btn btn-primary"
          />
        </div>
      </form>
    </div>
  );
};

export default PackageTranslationForm;
